import { useOnClickOutside } from "../../../hooks/useOnClickOutside.js";
import { useRef, useState } from "react";
import { Select, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useUpdateEffect } from "ahooks";
//#region src/components/CsvImportMapper/components/DataPreviewCell.tsx
function DataPreviewCell({ allowInlineEditing = true, columnMapping, onChangeValue, validationError, value }) {
	const [editing, setEditing] = useState(false);
	const [editedValue, setEditedValue] = useState(value);
	const inputRef = useRef(null);
	const [dropdownPosition, setDropdownPosition] = useState("left");
	useOnClickOutside(inputRef, () => setEditing(false));
	useUpdateEffect(() => {
		if (!editing) onChangeValue(editedValue);
	}, [editing]);
	const handlePositioning = () => {
		if (inputRef.current) {
			const rect = inputRef.current.getBoundingClientRect();
			const spaceOnRight = window.innerWidth - rect.right;
			setDropdownPosition(spaceOnRight < 200 ? "right" : "left");
		}
	};
	useUpdateEffect(() => {
		if (editing) {
			handlePositioning();
			const upHandler = ({ keyCode }) => {
				if (keyCode?.toString() === "13") setEditing(false);
			};
			window.addEventListener("keyup", upHandler);
			return () => {
				window.removeEventListener("keyup", upHandler);
			};
		}
	}, [editing]);
	if (editing) if (columnMapping.valueOptionsOnly && columnMapping.valueOptions) return /* @__PURE__ */ jsxs("div", {
		className: "relative h-full",
		ref: inputRef,
		children: [/* @__PURE__ */ jsx("div", {
			className: `absolute top-0 min-w-[200px] ${dropdownPosition === "left" ? "left-0" : "right-0"}`,
			children: /* @__PURE__ */ jsx(Select, {
				autoFocus: true,
				closeMenuOnSelect: true,
				valid: !validationError,
				isClearable: !columnMapping.required,
				options: columnMapping.valueOptions,
				onChangeValue: (v) => setEditedValue(v),
				allowCreate: !columnMapping.valueOptionsOnly,
				multi: columnMapping.allowMultiValue,
				value: editedValue
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "bg-main h-full min-h-0",
			children: "%nbsp;"
		})]
	});
	else return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		ref: inputRef,
		children: [/* @__PURE__ */ jsx("div", {
			className: `absolute top-0 min-w-[200px] whitespace-pre-wrap ${dropdownPosition === "left" ? "left-0" : "right-0"}`,
			children: /* @__PURE__ */ jsx(Text, {
				autoFocus: true,
				valid: !validationError,
				onChangeValue: setEditedValue,
				value: editedValue
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "bg-main h-full min-h-0",
			children: "%nbsp;"
		})]
	});
	return /* @__PURE__ */ jsx("div", {
		className: classnames("line-clamp-3 min-h-[25px] min-w-[50px]", {
			"bg-critical rounded": validationError,
			"hover:bg-surface-strong cursor-pointer": allowInlineEditing
		}),
		onClick: () => {
			if (allowInlineEditing) setEditing(true);
		},
		children: Array.isArray(value) ? value.join(", ") : value
	});
}
//#endregion
export { DataPreviewCell };

//# sourceMappingURL=DataPreviewCell.js.map